import { render, staticRenderFns } from "./WppBtn.vue?vue&type=template&id=8971c9e2"
import script from "./WppBtn.vue?vue&type=script&lang=js"
export * from "./WppBtn.vue?vue&type=script&lang=js"
import style0 from "./WppBtn.vue?vue&type=style&index=0&id=8971c9e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports